export const Blogdata = [
    {
        show: true,
        id: 1,
        BlogName: "My First Google Chrome Extension.(mark 15)",
        AboutBlog: "It's blog about How I created chrome extension",
        Date: "2021",
        url:"https://pranitcode.hashnode.dev/my-first-google-chrome-extension"
    },
    {
        show: true,
        id: 2,
        BlogName: "Understand git command.",
        AboutBlog: "About git and github",
        Date: "2021 sep",
        url:"https://pranitcode.hashnode.dev/understand-git-command"
    },
    {
        show: true,
        id: 3,
        BlogName: "Understand git command.",
        AboutBlog: "About git and github",
        Date: "2021 sep",
        url:"https://pranitcode.hashnode.dev/understand-git-command"
    },
    {
        show: true,
        id: 4,
        BlogName: "Understand git command.",
        AboutBlog: "About git and github",
        Date: "2021 sep",
        url:"https://pranitcode.hashnode.dev/understand-git-command"
    },
    
]